import { createSlice } from "@reduxjs/toolkit";

const orderFilterSlice = createSlice({
  name: "orderFilter",
  initialState: {
    status: null,
    search: null,
  },
  reducers: {
    setStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const {
  setStatusFilter,
  setSearchFilter,
  clearSearchFilter,
} = orderFilterSlice.actions;

export const selectOrderState = (state) => state.orderFilter;

export default orderFilterSlice.reducer;
